
import {
  
  FETCH_TABLE_REQUEST,
  FETCH_TABLE_SUCCESS,
  FETCH_TABLE_FAILURE,
  FETCH_FLOORS_SUCCESS,

  CREATE_TABLE_REQUEST,
  CREATE_TABLE_SUCCESS,
  CREATE_TABLE_FAILURE,

  UPDATE_TABLE_REQUEST,
  UPDATE_TABLE_SUCCESS,
  UPDATE_TABLE_FAILURE,

  DELETE_TABLE_REQUEST,
  DELETE_TABLE_SUCCESS,
  DELETE_TABLE_FAILURE,
} from "./tableActionTypes";

export const fetchTableRequest = () => ({
  type: FETCH_TABLE_REQUEST,
});

export const fetchTableSuccess = (data, dataType) => ({
  type: FETCH_TABLE_SUCCESS,
  payload: { data, type: dataType },
});

export const fetchFloorsSuccess = (floors) => ({
  type: FETCH_FLOORS_SUCCESS,
  payload: floors,
});

export const fetchTableFailure = (error) => ({
  type: FETCH_TABLE_FAILURE,
  payload: error,
});

export const createTableRequest = () => ({
  type: CREATE_TABLE_REQUEST,
});

export const createTableSuccess = (data, dataType) => ({
  type: CREATE_TABLE_SUCCESS,
  payload: { data, type: dataType },
});

export const createTableFailure = (error) => ({
  type: CREATE_TABLE_FAILURE,
  payload: error,
});

export const updateTableRequest = () => ({
  type: UPDATE_TABLE_REQUEST,
});

export const updateTableSuccess = (data, dataType) => ({
  type: UPDATE_TABLE_SUCCESS,
  payload: { data, type: dataType },
});

export const updateTableFailure = (error) => ({
  type: UPDATE_TABLE_FAILURE,
  payload: error,
});

export const deleteTableRequest = () => ({
  type: DELETE_TABLE_REQUEST,
});

export const deleteTableSuccess = (data, dataType) => ({
  type: DELETE_TABLE_SUCCESS,
  payload: { data, type: dataType },
});

export const deleteTableFailure = (error) => ({
  type: DELETE_TABLE_FAILURE,
  payload: error,
});
